import { Spin } from 'antd';
import download from 'downloadjs';
import moment from 'moment';
import React, { useState } from 'react';
import { BsCloudDownload } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import Apis from '../../../../../../api';
import { RootState } from '../../../../../../store/rootReducer';
import HSTable from '../../../../../common/HSTable';
import MessageActions from '../../../../../message/redux/actions';
import FileView from '../../../modal/FileView';
import { Audit, ExecutedAgreements } from '../../../redux/types';

const ExecutedAgreementsDesktop: React.FC = () => {
    const dispatch = useDispatch();

    const list = useSelector((state: RootState) => state.investments.executedAgreementsDoc);
    const loading = useSelector((state: RootState) => state.investments.eloading);
    const [downloadloading, setLoading] = useState<string | undefined>(undefined);

    const downloadDoc = (row: ExecutedAgreements) => {
        if (row.bookingUUID) {
            setLoading(row.uuid);
            Apis.downloadExecuteOrUpdateDoc(row.bookingUUID, row.uuid)
                .then((res) => {
                    download(
                        new Blob([res.data], { type: res.headers['content-type'] }),
                        row.title,
                        res.headers['content-type'],
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setLoading(undefined);
                });
        } else if (row.dealUUID) {
            setLoading(row.uuid);
            Apis.downloadDataRoomDocument(
                row.dealUUID,
                row.dealDocParentUUID || row.uuid,
                row.uuid,
                'ExecutedAgreements',
            )
                .then((res1) => {
                    download(
                        new Blob([res1.data], { type: res1.headers['content-type'] }),
                        row.title,
                        res1.headers['content-type'],
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoading(undefined);
                });
        }
    };

    const columns = [
        {
            dataIndex: 'title',
            title: 'Title',
        },
        {
            dataIndex: 'issuerName',
            title: 'Issuer',
        },
        {
            dataIndex: 'audit',
            title: 'Updated On',
            render: (audit: Audit) => (
                <span>{`${audit?.updatedAt ? moment(audit.updatedAt).format('DD/MM/YYYY HH:mm:ss') : ''}`}</span>
            ),
        },
        {
            dataIndex: 'view',
            title: 'View File',
            render: (text: string, row: ExecutedAgreements) => (
                <div className={text}>
                    <FileView
                        docUUID={row.uuid}
                        bookingUUID={row.bookingUUID}
                        pageType="invetmentDashboard"
                        fileName={row.title}
                        dealUUID={row.dealUUID}
                        rootUUID={row.dealDocParentUUID}
                        list={list}
                    />
                </div>
            ),
        },
        {
            dataIndex: 'download',
            title: 'Download',
            render: (text: string, row: ExecutedAgreements) => (
                <div className={text}>
                    {row.uuid ? (
                        downloadloading === row.uuid ? (
                            <Spin size="small" className="ml-2" />
                        ) : (
                            <BsCloudDownload
                                size={'1.2rem'}
                                onClick={() => {
                                    if (!downloadloading) downloadDoc(row);
                                }}
                            />
                        )
                    ) : (
                        ''
                    )}
                </div>
            ),
        },
    ];
    return (
        <div>
            <HSTable
                tableContainer={'investment'}
                columns={columns}
                data={list}
                loading={loading}
                pagination={{ isShow: true }}
                rowKey={(d: ExecutedAgreements) => `${d.uuid}_${uuidv4()}`}
                paginationPosition="bottomRight"
            />
        </div>
    );
};

export default ExecutedAgreementsDesktop;
